import React, { useEffect, useState } from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import SharedPresentation from '../components/share-presentation/SharedPresentation'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

const PresentationShare: React.FC = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const documentId = searchParams.get('formId')!.split('/')[0]
  const [showBlackout, setShowBlackout] = useState(false)

  const isLocalhost = window.location.hostname === 'localhost'

  useEffect(() => {
    const triggerBlackout = (reason: string) => {
      setShowBlackout(true)
      toast.error(`Protected: ${reason}`)

      // Optional: hide blackout after 10 seconds
      setTimeout(() => {
        setShowBlackout(false)
      }, 10000)
    }

    const disableContextMenu = (e: MouseEvent) => {
      if (!isLocalhost) {
        e.preventDefault()
        triggerBlackout('Right-click is disabled')
      }
    }

    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === 'PrintScreen') {
        navigator.clipboard.writeText('')
        triggerBlackout('Screenshot attempt blocked')
      }
    }

    window.addEventListener('keyup', handleKeyUp)
    document.addEventListener('contextmenu', disableContextMenu)

    return () => {
      window.removeEventListener('keyup', handleKeyUp)
      document.removeEventListener('contextmenu', disableContextMenu)
    }
  }, [isLocalhost])

  return (
    <>
      <SEOHead seo={getPageSEO("presentationShare")} />
      <div className="relative min-h-screen bg-white">
      {/* Blackout overlay */}
      {showBlackout && (
        <div className="fixed inset-0 z-50 bg-black transition-opacity duration-500" />
      )}

      <SharedPresentation formId={documentId} />
    </div>
    </>
  )
}

export default PresentationShare
